export default "__VITE_ASSET__B4INhh3R__"